"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Footer = void 0;

var tslib_1 = require("tslib");

var React = tslib_1.__importStar(require("react"));

var layout_1 = tslib_1.__importDefault(require("antd/es/layout"));

var __1 = require("..");

exports.Footer = function (_ref) {
  var footerImage = _ref.footerImage,
      footerImageMobile = _ref.footerImageMobile,
      socials = _ref.socials,
      children = _ref.children;
  return React.createElement(layout_1["default"].Footer, {
    className: 'clp-footer'
  }, footerImage && React.createElement("img", {
    src: footerImage,
    alt: "",
    className: 'clp-footer__img'
  }), footerImageMobile && React.createElement("img", {
    src: footerImageMobile,
    alt: "",
    className: 'clp-footer__img clp-footer__img_mob'
  }), React.createElement(__1.Container, null, children, React.createElement("nav", {
    className: "clp-footer__social"
  }, socials && socials.map(function (item) {
    return item;
  })), React.createElement("span", {
    className: 'clp-footer__info'
  }, "\xA9", new Date().getFullYear(), " by Cl\xE9 Priv\xE9e")));
};